module.exports = __webpack_public_path__ + "static/img/products discription_rooftop3.c13c4335.jpg";